enum Historic {
  GENERATE_BACKUP = 'GENERATE_BACKUP',
  UNDO_BACKUP = 'UNDO_BACKUP',
  REDO_BACKUP = 'REDO_BACKUP',
}

export const Mutations = {
  ...Historic,
};
